import { useAppDispatch, useAppSelector } from "store";

import { FC } from "react";
import LocationStoresSvg from "image/location-stores.svg";

import { selectedStoreSelector, toggleStoreSelectionModal } from "features";

interface IProps {
  className?: string;
}

export const CurrentStores: FC<IProps> = ({ className = "store-box" }) => {
  const dispatch = useAppDispatch();
  const selectedStore = useAppSelector(selectedStoreSelector);

  const handleClickStore = () => {
    dispatch(toggleStoreSelectionModal(true));
  };

  const displayText = selectedStore?.Адрес || "Магазин не выбран";

  return (
    <div className={className} onClick={handleClickStore}>
      <div className="box-img-store">
        <img src={LocationStoresSvg} alt="Магазин" className="img-store" width={21} height={20} />
      </div>
      <p className="name-store">{displayText}</p>
    </div>
  );
};

